import React, { useState } from "react";
import { FaCopy } from "react-icons/fa";
import JSONPretty from "react-json-pretty";
import "react-json-pretty/themes/monikai.css"; // Optional: JSONPretty theme
import { ToastContainer, toast } from "react-toastify";
import "react-toastify/dist/ReactToastify.css";
import "bootstrap/dist/css/bootstrap.min.css";
const OrganizationSchemaForm = () => {
  const [formData, setFormData] = useState({
    organizationType: "Organization",
    specificType: "",
    name: "",
    alternateName: "",
    url: "",
    logo: "",
    contactPoints: [],
    socialProfiles: [],
  });

  const [schema, setSchema] = useState({
     "@context": "https://schema.org", "@type": "Organization", "name": "", "alternateName": "", "url": "", "logo": "", "contactPoint": [], "sameAs": [] 
  });
  
  const handleInputChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
  };

  const addContactPoint = () => {
    setFormData({
      ...formData,
      contactPoints: [
        ...formData.contactPoints,
        { type: "", telephone: "", email: "" },
      ],
    });
  };

  const copyContactPoint = (index) => {
    const contactToCopy = formData.contactPoints[index];
    setFormData({
      ...formData,
      contactPoints: [...formData.contactPoints, { ...contactToCopy }],
    });
    toast.info("Contact Point copied successfully!");
  };

  const handleContactPointChange = (index, field, value) => {
    const updatedContactPoints = formData.contactPoints.map((contact, i) =>
      i === index ? { ...contact, [field]: value } : contact
    );
    setFormData({ ...formData, contactPoints: updatedContactPoints });
  };

  const removeContactPoint = (index) => {
    setFormData({
      ...formData,
      contactPoints: formData.contactPoints.filter((_, i) => i !== index),
    });
    toast.warn("Contact Point removed!");
  };

  const addSocialProfile = () => {
    setFormData({
      ...formData,
      socialProfiles: [...formData.socialProfiles, ""],
    });
  };

  const copySocialProfile = (index) => {
    const profileToCopy = formData.socialProfiles[index];
    setFormData({
      ...formData,
      socialProfiles: [...formData.socialProfiles, profileToCopy],
    });
    toast.info("Social Profile copied successfully!");
  };

  const handleSocialProfileChange = (index, value) => {
    const updatedProfiles = formData.socialProfiles.map((profile, i) =>
      i === index ? value : profile
    );
    setFormData({ ...formData, socialProfiles: updatedProfiles });
  };

  const removeSocialProfile = (index) => {
    setFormData({
      ...formData,
      socialProfiles: formData.socialProfiles.filter((_, i) => i !== index),
    });
    toast.warn("Social Profile removed!");
  };

  const generateSchema = () => {
    return {
      "@context": "https://schema.org",
      "@type": formData.organizationType,
      name: formData.name,
      alternateName: formData.alternateName,
      url: formData.url,
      logo: formData.logo,
      contactPoint: formData.contactPoints.map((contact) => ({
        "@type": "ContactPoint",
        contactType: contact.type,
        telephone: contact.telephone,
        email: contact.email,
      })),
      sameAs: formData.socialProfiles,
    };
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const generatedSchema = generateSchema();
    setSchema(generatedSchema);
    toast.success("Schema generated successfully!");
  };

  const copyToClipboard = () => {
    if (schema) {
      navigator.clipboard.writeText(JSON.stringify(schema, null, 2)).then(() => {
        toast.info("JSON-LD copied to clipboard!");
      });
    } else {
      toast.error("Generate the schema first!");
    }
  };;
  const deleteSchema = () => {
    setSchema({
      "@context": "https://schema.org", "@type": "Organization", "name": "", "alternateName": "", "url": "", "logo": "", "contactPoint": [], "sameAs": [] 
   });
    toast.warning("Schema reset to dummy data!");
  };
  
  return (
    <div className="container mt-4">
        <ToastContainer/>
     
      <div className="row">
        <div className="col-md-6">
        <form onSubmit={handleSubmit} className="card p-4 shadow-sm">
        {/* Organization Type and Specific Type */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Organization @type</label>
            <select
              name="organizationType"
              className="form-select"
              value={formData.organizationType}
              onChange={handleInputChange}
            >
              <option value="Organization">Organization</option>
              <option value="NGO">NGO</option>
              <option value="Corporation">Corporation</option>
            </select>
          </div>
          <div className="col-md-6">
            <label className="form-label">More specific @type</label>
            <input
              type="text"
              className="form-control"
              name="specificType"
              value={formData.specificType}
              onChange={handleInputChange}
              placeholder="e.g., Software Company, Charity"
            />
          </div>
        </div>

        {/* Name, Alternate Name, URL, and Logo */}
        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">Name</label>
            <input
              type="text"
              className="form-control"
              name="name"
              value={formData.name}
              onChange={handleInputChange}
              placeholder="Enter organization name"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Alternate Name</label>
            <input
              type="text"
              className="form-control"
              name="alternateName"
              value={formData.alternateName}
              onChange={handleInputChange}
              placeholder="Enter alternate name"
            />
          </div>
        </div>

        <div className="row mb-3">
          <div className="col-md-6">
            <label className="form-label">URL</label>
            <input
              type="text"
              className="form-control"
              name="url"
              value={formData.url}
              onChange={handleInputChange}
              placeholder="Enter organization URL"
            />
          </div>
          <div className="col-md-6">
            <label className="form-label">Logo URL</label>
            <input
              type="text"
              className="form-control"
              name="logo"
              value={formData.logo}
              onChange={handleInputChange}
              placeholder="Enter logo URL"
            />
          </div>
        </div>

        {/* Contact Points */}
        <div className="mb-3">
          <label className="form-label">Contact Points</label>
          {formData.contactPoints.map((contact, index) => (
            <div key={index} className="row align-items-end mb-2">
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  value={contact.type}
                  onChange={(e) =>
                    handleContactPointChange(index, "type", e.target.value)
                  }
                  placeholder="Contact type (e.g., Customer Service)"
                />
              </div>
              <div className="col-md-3">
                <input
                  type="text"
                  className="form-control"
                  value={contact.telephone}
                  onChange={(e) =>
                    handleContactPointChange(index, "telephone", e.target.value)
                  }
                  placeholder="Telephone"
                />
              </div>
              <div className="col-md-3">
                <input
                  type="email"
                  className="form-control"
                  value={contact.email}
                  onChange={(e) =>
                    handleContactPointChange(index, "email", e.target.value)
                  }
                  placeholder="Email"
                />
              </div>
              <div className="col-md-3 text-end">
                
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => removeContactPoint(index)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
          <button type="button" className="btn btn-primary" onClick={addContactPoint}>
            + Add Contact
          </button>
        </div>

        {/* Social Profiles */}
        <div className="mb-3">
          <label className="form-label">Social Profiles</label>
          {formData.socialProfiles.map((profile, index) => (
            <div key={index} className="row align-items-end mb-2">
              <div className="col-md-10">
                <input
                  type="text"
                  className="form-control"
                  value={profile}
                  onChange={(e) => handleSocialProfileChange(index, e.target.value)}
                  placeholder="Enter social profile URL"
                />
              </div>
              <div className="col-md-2 text-end">
                
                <button
                  type="button"
                  className="btn btn-danger"
                  onClick={() => removeSocialProfile(index)}
                >
                  Delete
                </button>
              </div>
            </div>
          ))}
          <button type="button" className="btn btn-primary" onClick={addSocialProfile}>
            + Add Social Profile
          </button>
        </div>

        {/* Submit Button */}
        <button type="submit" className="btn btn-success w-100">
          Generate Schema
        </button>
      </form>
        </div>



      {/* JSON-LD Preview */}
      {/* JSON-LD Preview Section */}
      <div className="col-md-6">
          <div className="card shadow-sm p-4">
            <h5 className="card-title text-center mb-4">Generated JSON-LD</h5>
            <div>
                <button
                  className="btn btn-primary"
                  onClick={copyToClipboard}
                >
                  Copy
                </button>
                <button
                  className="btn btn-danger ms-2"
                  onClick={deleteSchema}
                >
                  Reset
                </button>
                <button
                  className="btn btn-info ms-2"
                  
                >
                  <a  target="_blank" className="text-decoration-none text-white" href="https://developers.google.com/search/docs/appearance/structured-data">Validate</a>
                </button>
                <button
                  className="btn btn-success ms-2"
                  
                >
                  <a target="_blank" className="text-decoration-none text-white" href="https://search.google.com/test/rich-results">Test</a>
                </button>
                </div>
            {schema ? (
              <div className="position-relative">
                <JSONPretty
                  id="json-pretty"
                  data={schema}
                  className="bg-light p-3 rounded border"
                ></JSONPretty>
               
              </div>
            ) : (
              <p className="text-center">No schema generated yet.</p>
            )}
          </div>
        </div>
        </div>
    </div>
  );
};

export default OrganizationSchemaForm;
